module.exports = __webpack_public_path__ + "img/icon-x-circle.a8697cb8.svg";